export default {
  getInitialData({ dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      dispatch('startLoading', 'initial-data')
      const initialRequests = []

      initialRequests.push(dispatch('getAllProjects'))
      initialRequests.push(dispatch('getAllLayerTypes'))
      initialRequests.push(dispatch('getAllDocumentTypes'))
      initialRequests.push(dispatch('getAllContactMethods'))
      initialRequests.push(dispatch('getAllVisitResults'))
      initialRequests.push(dispatch('getAllPaymentMethods'))
      initialRequests.push(dispatch('getAllUsers'))

      return Promise.all(initialRequests)
        .then(() => {
          dispatch('endLoading', 'initial-data')
          resolve()
        })
        .catch(response => {
          dispatch('endLoading', 'initial-data')
          reject(response)
        })
    })
  },
  setInitialDataLoaded({ commit, state }, value) {
    commit('SET_ITEM', {
      item: value,
      state,
      modelName: 'initialDataLoaded'
    })
  },
  setCurrentRoute(context, payload) {
    context.commit('SET_CURRENT_ROUTE', payload)
  },
  setMenuCollapsed({ commit }, payload) {
    commit('SET_MENU_COLLAPSED', payload)
    // Persist to localStorage
    localStorage.setItem('sidebarCollapsed', JSON.stringify(payload))
  },
  loadSidebarState({ commit }) {
    const collapsed = localStorage.getItem('sidebarCollapsed')
    if (collapsed !== null) {
      commit('SET_MENU_COLLAPSED', JSON.parse(collapsed))
    }
  },
  setFullScreen({ commit }, payload) {
    commit('SET_FULL_SCREEN', payload)
  },
  setDarkMode({ commit }, payload) {
    commit('SET_DARK_MODE', payload)
  },
  setSidebarVisible({ commit }, payload) {
    commit('SET_SIDEBAR_VISIBLE', payload)
  },
  toggleQuickSearch({ commit, state }) {
    commit('SET_QUICK_SEARCH_VISIBLE', !state.quickSearchVisible)
  },
  openQuickSearch({ commit }) {
    commit('SET_QUICK_SEARCH_VISIBLE', true)
  },
  closeQuickSearch({ commit }) {
    commit('SET_QUICK_SEARCH_VISIBLE', false)
  }
}
